<template>
  <div>
    <card
      class="home-card custom-shadow-card-header"
      :showHr="false"
      :style="`height: ${height}px !important;`"
    >
      <span>
        <div class="row">
          <div class="col-12">
            <div class="row mb-4">
              <div class="col-6 col-md-8">
                <img
                  class="chart-logo"
                  src="/static/img/iconos/icono-color-plaga.svg"
                />
                <span class="ml-1 custom-title"
                  ><strong>{{
                    $t('diseases.plagues_and_diseases')
                  }}</strong></span
                >
              </div>
              <div class="col-6 col-md-4 text-right">
                <span class="custom-subtitle text-muted">{{
                  $t('diseases.plagues_and_diseases_total')
                }}</span>
              </div>
            </div>
            <highcharts :options="pieChartOptions"></highcharts>
          </div>
        </div>
      </span>
      <div slot="footer" class="card-footer footer-date-at custom-opacity">
        <p class="text-muted-custom d-flex justify-content-between">
          <small class="ml-3">{{ $t('common_words.smart_cultivo') }}</small>
          <small class="mr-3">{{ $t('common_words.last_six_months') }}</small>
        </p>
      </div>
    </card>
  </div>
</template>

<script>
import axios from 'axios';
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import MixinCharts from 'src/util/mixinCharts';

exportingInit(Highcharts);

export default {
  components: {
    highcharts: Chart,
  },
  props: {
    height: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      pieChartOptions: {},
    };
  },
  mixins: [MixinCharts],
  methods: {
    getPieChartData() {
      return axios.get('/auth/diseases/piechart').then((response) => {
        response.data.height = `${this.height - 200}px`;
        this.pieChartOptions = this.pieChart(response.data, null, true);
      });
    },
  },
  async created() {
    await this.getPieChartData();
  },
};
</script>
<style>
.text-muted-custom {
  color: #ffffff !important;
}
</style>
